import { render } from "./Terminal.vue?vue&type=template&id=38d6ddc4&bindings={}"
import script from "./Terminal.vue?vue&type=script&lang=ts"
export * from "./Terminal.vue?vue&type=script&lang=ts"

import "./Terminal.vue?vue&type=style&index=0&lang=postcss"
script.render = render

export default script